module.exports = __webpack_public_path__ + "img/bo.ffb2d870.png";